export function pickItems(items, roll) {
  let i
  const weights = []

  for (i = 0; i < items.length; i++) {
    weights[i] = items[i].weight + (weights[i - 1] || 0)
  }

  const randomStop = roll * weights[weights.length - 1]

  for (i = 0; i < items.length; i++) {
    if (weights[i] > randomStop) break
  }

  return items[i]
}
